import { Flex, Layout, Menu } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex).attrs({ vertical: true })`
  height: 100%;
  padding: 16px;
`;
